import { render } from "./IndexView.vue?vue&type=template&id=9c19245e&scoped=true&ts=true"
import script from "./IndexView.vue?vue&type=script&lang=ts"
export * from "./IndexView.vue?vue&type=script&lang=ts"

import "./IndexView.vue?vue&type=style&index=0&id=9c19245e&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/webapp/webapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9c19245e"]])

export default __exports__